export const selectRecordingTranscriptsByFileId = (state) => fileId => {
    const recordingTranscripts = Object.values(state.entities.recording_transcripts.byId)
        .find(item => item.fileId === fileId);
    return recordingTranscripts ? recordingTranscripts.transcript : [];
};
export const selectSearchTranscripts = (state) => {
    const searchTranscripts = Object.values(state.entities.search_transcripts.byId);
    return searchTranscripts ? searchTranscripts : [];
};
